import { IconProps } from "../../../lib/types";

const Hours: React.FC<IconProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28.378"
      height="28.378"
      viewBox="0 0 28.378 28.378"
      className={className}
    >
      <defs>
        <style></style>
      </defs>
      <path
        d="M22.189,8A14.189,14.189,0,1,0,36.378,22.189,14.186,14.186,0,0,0,22.189,8ZM34.547,22.189A12.358,12.358,0,1,1,22.189,9.831,12.358,12.358,0,0,1,34.547,22.189Zm-8.519,5.052-4.646-3.376a.691.691,0,0,1-.28-.555V14.179a.689.689,0,0,1,.687-.687h.8a.689.689,0,0,1,.687.687v8.37l4.034,2.935a.686.686,0,0,1,.149.961l-.469.647a.691.691,0,0,1-.961.149Z"
        transform="translate(-8 -8)"
      />
    </svg>
  );
};

export default Hours;
